export * from './lib/order-confirmation.routes';
export * from './lib/pages/order-confirmation/order-confirmation.component';
